// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentationContent-module__font-s-10___FT1kE {
  font-size: 10px !important;
}

.DocumentationContent-module__font-s-12___CUvwa {
  font-size: 12px !important;
}

.DocumentationContent-module__font-s-13___pRBZy {
  font-size: 13px !important;
}

.DocumentationContent-module__font-s-14___Tiia5 {
  font-size: 14px !important;
}

.DocumentationContent-module__font-s-15___rYgoT {
  font-size: 15px !important;
}

.DocumentationContent-module__font-s-16___C9Wlx {
  font-size: 16px !important;
}

.DocumentationContent-module__font-s-18___dYfGR {
  font-size: 18px !important;
}

.DocumentationContent-module__font-s-20___AGive {
  font-size: 20px !important;
}

.DocumentationContent-module__font-s-22___Xw5Oh {
  font-size: 22px !important;
}

.DocumentationContent-module__font-s-28___NLd7N {
  font-size: 28px !important;
}

.DocumentationContent-module__font-w-400___oJ6Es {
  font-weight: 400 !important;
}

.DocumentationContent-module__font-w-500___SX0qG {
  font-weight: 500 !important;
}

.DocumentationContent-module__font-w-600___hrsW0 {
  font-weight: 600 !important;
}

.DocumentationContent-module__font-w-700___QCaNT {
  font-weight: 700 !important;
}

.DocumentationContent-module__p-5___l1C2n {
  padding: 5px !important;
}

.DocumentationContent-module__p-12___uump4 {
  padding: 12px !important;
}

.DocumentationContent-module__p-16___Rc0PV {
  padding: 16px !important;
}

.DocumentationContent-module__p-30___mlWlt {
  padding: 30px !important;
}

.DocumentationContent-module__p-b-0___E1LYf {
  padding-bottom: 0 !important;
}

.DocumentationContent-module__p-b-5___DFn7q {
  padding-bottom: 5px !important;
}

.DocumentationContent-module__p-b-10___BMKr0 {
  padding-bottom: 10px !important;
}

.DocumentationContent-module__p-b-12___XffPr {
  padding-bottom: 12px !important;
}

.DocumentationContent-module__p-b-16___ocOo6 {
  padding-bottom: 16px !important;
}

.DocumentationContent-module__p-b-18___eC2Ij {
  padding-bottom: 18px !important;
}

.DocumentationContent-module__p-b-20___W5jRP {
  padding-bottom: 20px !important;
}

.DocumentationContent-module__p-b-25___A0yAs {
  padding-bottom: 25px !important;
}

.DocumentationContent-module__p-b-30___KTE4e {
  padding-bottom: 30px !important;
}

.DocumentationContent-module__p-b-50___f59Cq {
  padding-bottom: 50px !important;
}

.DocumentationContent-module__p-t-0___UZBCE {
  padding-top: 0 !important;
}

.DocumentationContent-module__p-t-12___KQB1g {
  padding-top: 12px !important;
}

.DocumentationContent-module__p-t-16___EqQHn {
  padding-top: 16px !important;
}

.DocumentationContent-module__p-t-18___ugCPX {
  padding-top: 18px !important;
}

.DocumentationContent-module__p-t-20___AZzZl {
  padding-top: 20px !important;
}

.DocumentationContent-module__p-t-30___JaACR {
  padding-top: 30px !important;
}

.DocumentationContent-module__p-t-40___SO23P {
  padding-top: 40px !important;
}

.DocumentationContent-module__p-t-50___jNyjo {
  padding-top: 50px !important;
}

.DocumentationContent-module__p-l-20___Y81fo {
  padding-left: 20px !important;
}

.DocumentationContent-module__p-l-30___ojsEh {
  padding-left: 30px !important;
}

.DocumentationContent-module__p-l-40___c8XX_ {
  padding-left: 40px !important;
}

.DocumentationContent-module__p-r-16____fNLn {
  padding-right: 16px !important;
}

.DocumentationContent-module__p-r-20___XIArY {
  padding-right: 20px !important;
}

.DocumentationContent-module__p-r-30____gXSb {
  padding-right: 30px !important;
}

.DocumentationContent-module__p-r-50___pMkYo {
  padding-right: 50px !important;
}

.DocumentationContent-module__p-r-60___aln7W {
  padding-right: 60px !important;
}

.DocumentationContent-module__m-b-1___Yd3zO {
  margin-bottom: 1px !important;
}

.DocumentationContent-module__m-b-2___JDmI_ {
  margin-bottom: 2px !important;
}

.DocumentationContent-module__m-b-6___F0X82 {
  margin-bottom: 6px !important;
}

.DocumentationContent-module__m-b-8___wdlEs {
  margin-bottom: 8px !important;
}

.DocumentationContent-module__m-b-10___K8nXy {
  margin-bottom: 10px !important;
}

.DocumentationContent-module__m-b-14___cHyVC {
  margin-bottom: 14px !important;
}

.DocumentationContent-module__m-b-16___ik2Pj {
  margin-bottom: 16px !important;
}

.DocumentationContent-module__m-b-20___v6qtz {
  margin-bottom: 20px !important;
}

.DocumentationContent-module__m-b-22___f36fu {
  margin-bottom: 22px !important;
}

.DocumentationContent-module__m-b-24___f3WZu {
  margin-bottom: 24px !important;
}

.DocumentationContent-module__m-b-30___DSOWS {
  margin-bottom: 30px !important;
}

.DocumentationContent-module__m-b-32___ZGIJP {
  margin-bottom: 32px !important;
}

.DocumentationContent-module__m-b-40___gv1k7 {
  margin-bottom: 40px !important;
}

.DocumentationContent-module__m-t-2___aEfQZ {
  margin-top: 2px !important;
}

.DocumentationContent-module__m-t-3___vySLf {
  margin-top: 3px !important;
}

.DocumentationContent-module__m-t-4___TAASN {
  margin-top: 4px !important;
}

.DocumentationContent-module__m-t-5___MeSjf {
  margin-top: 5px !important;
}

.DocumentationContent-module__m-t-8___bSp2U {
  margin-top: 8px !important;
}

.DocumentationContent-module__m-t-10___qTbhE {
  margin-top: 10px !important;
}

.DocumentationContent-module__m-t-15___LpaX3 {
  margin-top: 15px !important;
}

.DocumentationContent-module__m-t-16___cjzkt {
  margin-top: 16px !important;
}

.DocumentationContent-module__m-t-20___lMrWd {
  margin-top: 20px !important;
}

.DocumentationContent-module__m-t-22___Y61u5 {
  margin-top: 22px !important;
}

.DocumentationContent-module__m-t-30___iFbJ8 {
  margin-top: 30px !important;
}

.DocumentationContent-module__m-t-32___XQw8g {
  margin-top: 32px !important;
}

.DocumentationContent-module__m-l-auto___d1afj {
  margin-left: auto !important;
}

.DocumentationContent-module__m-l-4___vma4r {
  margin-left: 4px !important;
}

.DocumentationContent-module__m-l-5___jPZG1 {
  margin-left: 5px !important;
}

.DocumentationContent-module__m-l-6___B3slC {
  margin-left: 6px !important;
}

.DocumentationContent-module__m-l-8___sZOpy {
  margin-left: 8px !important;
}

.DocumentationContent-module__m-l-10___do9yA {
  margin-left: 10px !important;
}

.DocumentationContent-module__m-l-16___vGiff {
  margin-left: 16px !important;
}

.DocumentationContent-module__m-l-20____1HM2 {
  margin-left: 20px !important;
}

.DocumentationContent-module__m-l-24___UHut_ {
  margin-left: 24px !important;
}

.DocumentationContent-module__m-l-30___ir1rY {
  margin-left: 30px !important;
}

.DocumentationContent-module__m-l-35___ULgEy {
  margin-left: 35px !important;
}

.DocumentationContent-module__m-l-40___RnhOX {
  margin-left: 40px !important;
}

.DocumentationContent-module__m-r-8___vEeZa {
  margin-right: 8px !important;
}

.DocumentationContent-module__m-r-10___TJbql {
  margin-right: 10px !important;
}

.DocumentationContent-module__m-r-16___FNBXd {
  margin-right: 16px !important;
}

.DocumentationContent-module__m-r-20___w0PL_ {
  margin-right: 20px !important;
}

.DocumentationContent-module__m-r-24___ePQCC {
  margin-right: 24px !important;
}

.DocumentationContent-module__m-r-30___FlPAe {
  margin-right: 30px !important;
}

.DocumentationContent-module__m-r-40___NtlHU {
  margin-right: 40px !important;
}

.DocumentationContent-module__border-r-3___JVhIX {
  border-radius: 3px !important;
}

.DocumentationContent-module__border-r-4___LRTfT {
  border-radius: 4px !important;
}

.DocumentationContent-module__border-r-6___vGGFE {
  border-radius: 6px !important;
}

.DocumentationContent-module__border-r-10____84gO {
  border-radius: 10px !important;
}

.DocumentationContent-module__border-r-12___YQHIP {
  border-radius: 12px !important;
}

.DocumentationContent-module__border-r-16___LYj9g {
  border-radius: 16px !important;
}

.DocumentationContent-module__border-r-50___ElL3Y {
  border-radius: 50% !important;
}

.DocumentationContent-module__primary-border___d126n {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationContent-module__primary-border-b___tel_5 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationContent-module__primary-border-t___Xi3yG {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationContent-module__primary-border-l___Pl0BR {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationContent-module__primary-border-r___tw48A {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationContent-module__secondary-border___al8Wz {
  border: 1px solid #637768;
}

.DocumentationContent-module__secondary-border-b___I2uXq {
  border-bottom: 1px solid #637768;
}

.DocumentationContent-module__secondary-border-t___nZDie {
  border-top: 1px solid #637768;
}

.DocumentationContent-module__secondary-border-l___BxP_7 {
  border-left: 1px solid #637768;
}

.DocumentationContent-module__secondary-border-r___oLz63 {
  border-right: 1px solid #637768;
}

.DocumentationContent-module__gap-0___mP2bC {
  gap: 0 !important;
}

.DocumentationContent-module__gap-2___q0Zdj {
  gap: 2px !important;
}

.DocumentationContent-module__gap-4___Jf6Yq {
  gap: 4px !important;
}

.DocumentationContent-module__gap-5___OFONh {
  gap: 5px !important;
}

.DocumentationContent-module__gap-6___riDAe {
  gap: 6px !important;
}

.DocumentationContent-module__gap-8___DrTa7 {
  gap: 8px !important;
}

.DocumentationContent-module__gap-10___OdAEa {
  gap: 10px !important;
}

.DocumentationContent-module__gap-12___hKoz6 {
  gap: 12px !important;
}

.DocumentationContent-module__gap-14___HMRZJ {
  gap: 14px !important;
}

.DocumentationContent-module__gap-16___nwUHn {
  gap: 16px !important;
}

.DocumentationContent-module__gap-18___IViNS {
  gap: 18px !important;
}

.DocumentationContent-module__gap-20___DRylB {
  gap: 20px !important;
}

.DocumentationContent-module__gap-24___rAc1x {
  gap: 24px !important;
}

.DocumentationContent-module__gap-26___Iblkc {
  gap: 26px !important;
}

.DocumentationContent-module__gap-30___pMnLm {
  gap: 30px !important;
}

.DocumentationContent-module__gap-32___Tyc1n {
  gap: 32px !important;
}

.DocumentationContent-module__gap-40___dag90 {
  gap: 40px !important;
}

.DocumentationContent-module__gap-50___diwTk {
  gap: 50px !important;
}

.DocumentationContent-module__flex-1___IkQ6t {
  flex: 1;
}

.DocumentationContent-module__flex-none___zYnFj {
  flex: none !important;
}

.DocumentationContent-module__flex-column___rA0Nk {
  display: flex;
  flex-direction: column !important;
}

.DocumentationContent-module__flex-row___IkJvj {
  display: flex;
  flex-direction: row !important;
}

.DocumentationContent-module__vertically-centered___WykJr {
  display: flex;
  align-items: center !important;
}

.DocumentationContent-module__horizontally-centered___x9RML {
  display: flex;
  justify-content: center !important;
}

.DocumentationContent-module__horizontally-end___BBKjl {
  display: flex;
  justify-content: end !important;
}

.DocumentationContent-module__vertically-start___IhzRU {
  display: flex;
  align-items: start !important;
}

.DocumentationContent-module__space-between___EgFbA {
  display: flex;
  justify-content: space-between !important;
}

.DocumentationContent-module__flex-wrap___SLvf3 {
  flex-wrap: wrap !important;
}

.DocumentationContent-module__height-100___AEcdK {
  height: 100%;
}

.DocumentationContent-module__width-50___yp76z {
  width: 50% !important;
}

.DocumentationContent-module__width-100___BpoCz {
  width: 100%;
}

.DocumentationContent-module__cursor-pointer___iZjj3 {
  cursor: pointer;
}

.DocumentationContent-module__cursor-not-allowed___mlM5K {
  cursor: not-allowed !important;
}

.DocumentationContent-module__absolute-centered___bNNRX {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DocumentationContent-module__absolute___fueqX {
  position: absolute;
}

.DocumentationContent-module__relative___Jx5st {
  position: relative;
}

.DocumentationContent-module__fixed___Fk79K {
  position: fixed;
}

.DocumentationContent-module__visible___Jnohw {
  opacity: 1;
}

.DocumentationContent-module__invisible___pyXnZ {
  opacity: 0;
}

.DocumentationContent-module__col-90___fK14X {
  width: 90% !important;
}

.DocumentationContent-module__col-auto___eNZ40 {
  width: auto !important;
}

.DocumentationContent-module__medical-tabs___PvbP5 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DocumentationContent-module__medical-table-new___RyqDL {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationContent-module__medical-table-new___RyqDL:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationContent-module__medical-table-new___RyqDL::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationContent-module__medical-table-new___RyqDL::-webkit-scrollbar-track {
  display: none;
}
.DocumentationContent-module__medical-table-new___RyqDL.DocumentationContent-module__no-pagination___Iyyjs {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationContent-module__medical-table-new___RyqDL.DocumentationContent-module__no-pagination___Iyyjs:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationContent-module__medical-table-new___RyqDL.DocumentationContent-module__no-pagination___Iyyjs::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationContent-module__medical-table-new___RyqDL.DocumentationContent-module__no-pagination___Iyyjs::-webkit-scrollbar-track {
  display: none;
}

.DocumentationContent-module__medical-table-empty___hwAeh {
  padding: 14px 40px !important;
}

.DocumentationContent-module__icon-btn___NXwAJ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DocumentationContent-module__search-icon___H5Is9 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DocumentationContent-module__disable-select___RDtSQ {
  user-select: none;
}

.DocumentationContent-module__break-word___w3CIi {
  word-break: break-word;
}

.DocumentationContent-module__popup-clear-btn___fojBu {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DocumentationContent-module__scroll-m-b-20___wLRIm {
  scroll-margin-bottom: 20px;
}

.DocumentationContent-module__wrapper___fytH0 {
  margin: 0 40px;
}
.DocumentationContent-module__wrapper___fytH0 .DocumentationContent-module__item___bf9C8 {
  border-bottom: none;
  padding: 20px 5px;
  flex: 1;
}

.DocumentationContent-module__note___LNA1q {
  color: #375844;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  margin: 20px 40px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DocumentationFragment/items/DocumentationContent/DocumentationContent.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,mBAAA;EACA,iBAAA;EACA,OAAA;AA8pBJ;;AA1pBA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  margin: 0 40px;\n\n  .item {\n    border-bottom: none;\n    padding: 20px 5px;\n    flex: 1;\n  }\n}\n\n.note {\n  color: get-color(greenNew, dark);\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  margin: 20px 40px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DocumentationContent-module__font-s-10___FT1kE`,
	"fontS12": `DocumentationContent-module__font-s-12___CUvwa`,
	"fontS13": `DocumentationContent-module__font-s-13___pRBZy`,
	"fontS14": `DocumentationContent-module__font-s-14___Tiia5`,
	"fontS15": `DocumentationContent-module__font-s-15___rYgoT`,
	"fontS16": `DocumentationContent-module__font-s-16___C9Wlx`,
	"fontS18": `DocumentationContent-module__font-s-18___dYfGR`,
	"fontS20": `DocumentationContent-module__font-s-20___AGive`,
	"fontS22": `DocumentationContent-module__font-s-22___Xw5Oh`,
	"fontS28": `DocumentationContent-module__font-s-28___NLd7N`,
	"fontW400": `DocumentationContent-module__font-w-400___oJ6Es`,
	"fontW500": `DocumentationContent-module__font-w-500___SX0qG`,
	"fontW600": `DocumentationContent-module__font-w-600___hrsW0`,
	"fontW700": `DocumentationContent-module__font-w-700___QCaNT`,
	"p5": `DocumentationContent-module__p-5___l1C2n`,
	"p12": `DocumentationContent-module__p-12___uump4`,
	"p16": `DocumentationContent-module__p-16___Rc0PV`,
	"p30": `DocumentationContent-module__p-30___mlWlt`,
	"pB0": `DocumentationContent-module__p-b-0___E1LYf`,
	"pB5": `DocumentationContent-module__p-b-5___DFn7q`,
	"pB10": `DocumentationContent-module__p-b-10___BMKr0`,
	"pB12": `DocumentationContent-module__p-b-12___XffPr`,
	"pB16": `DocumentationContent-module__p-b-16___ocOo6`,
	"pB18": `DocumentationContent-module__p-b-18___eC2Ij`,
	"pB20": `DocumentationContent-module__p-b-20___W5jRP`,
	"pB25": `DocumentationContent-module__p-b-25___A0yAs`,
	"pB30": `DocumentationContent-module__p-b-30___KTE4e`,
	"pB50": `DocumentationContent-module__p-b-50___f59Cq`,
	"pT0": `DocumentationContent-module__p-t-0___UZBCE`,
	"pT12": `DocumentationContent-module__p-t-12___KQB1g`,
	"pT16": `DocumentationContent-module__p-t-16___EqQHn`,
	"pT18": `DocumentationContent-module__p-t-18___ugCPX`,
	"pT20": `DocumentationContent-module__p-t-20___AZzZl`,
	"pT30": `DocumentationContent-module__p-t-30___JaACR`,
	"pT40": `DocumentationContent-module__p-t-40___SO23P`,
	"pT50": `DocumentationContent-module__p-t-50___jNyjo`,
	"pL20": `DocumentationContent-module__p-l-20___Y81fo`,
	"pL30": `DocumentationContent-module__p-l-30___ojsEh`,
	"pL40": `DocumentationContent-module__p-l-40___c8XX_`,
	"pR16": `DocumentationContent-module__p-r-16____fNLn`,
	"pR20": `DocumentationContent-module__p-r-20___XIArY`,
	"pR30": `DocumentationContent-module__p-r-30____gXSb`,
	"pR50": `DocumentationContent-module__p-r-50___pMkYo`,
	"pR60": `DocumentationContent-module__p-r-60___aln7W`,
	"mB1": `DocumentationContent-module__m-b-1___Yd3zO`,
	"mB2": `DocumentationContent-module__m-b-2___JDmI_`,
	"mB6": `DocumentationContent-module__m-b-6___F0X82`,
	"mB8": `DocumentationContent-module__m-b-8___wdlEs`,
	"mB10": `DocumentationContent-module__m-b-10___K8nXy`,
	"mB14": `DocumentationContent-module__m-b-14___cHyVC`,
	"mB16": `DocumentationContent-module__m-b-16___ik2Pj`,
	"mB20": `DocumentationContent-module__m-b-20___v6qtz`,
	"mB22": `DocumentationContent-module__m-b-22___f36fu`,
	"mB24": `DocumentationContent-module__m-b-24___f3WZu`,
	"mB30": `DocumentationContent-module__m-b-30___DSOWS`,
	"mB32": `DocumentationContent-module__m-b-32___ZGIJP`,
	"mB40": `DocumentationContent-module__m-b-40___gv1k7`,
	"mT2": `DocumentationContent-module__m-t-2___aEfQZ`,
	"mT3": `DocumentationContent-module__m-t-3___vySLf`,
	"mT4": `DocumentationContent-module__m-t-4___TAASN`,
	"mT5": `DocumentationContent-module__m-t-5___MeSjf`,
	"mT8": `DocumentationContent-module__m-t-8___bSp2U`,
	"mT10": `DocumentationContent-module__m-t-10___qTbhE`,
	"mT15": `DocumentationContent-module__m-t-15___LpaX3`,
	"mT16": `DocumentationContent-module__m-t-16___cjzkt`,
	"mT20": `DocumentationContent-module__m-t-20___lMrWd`,
	"mT22": `DocumentationContent-module__m-t-22___Y61u5`,
	"mT30": `DocumentationContent-module__m-t-30___iFbJ8`,
	"mT32": `DocumentationContent-module__m-t-32___XQw8g`,
	"mLAuto": `DocumentationContent-module__m-l-auto___d1afj`,
	"mL4": `DocumentationContent-module__m-l-4___vma4r`,
	"mL5": `DocumentationContent-module__m-l-5___jPZG1`,
	"mL6": `DocumentationContent-module__m-l-6___B3slC`,
	"mL8": `DocumentationContent-module__m-l-8___sZOpy`,
	"mL10": `DocumentationContent-module__m-l-10___do9yA`,
	"mL16": `DocumentationContent-module__m-l-16___vGiff`,
	"mL20": `DocumentationContent-module__m-l-20____1HM2`,
	"mL24": `DocumentationContent-module__m-l-24___UHut_`,
	"mL30": `DocumentationContent-module__m-l-30___ir1rY`,
	"mL35": `DocumentationContent-module__m-l-35___ULgEy`,
	"mL40": `DocumentationContent-module__m-l-40___RnhOX`,
	"mR8": `DocumentationContent-module__m-r-8___vEeZa`,
	"mR10": `DocumentationContent-module__m-r-10___TJbql`,
	"mR16": `DocumentationContent-module__m-r-16___FNBXd`,
	"mR20": `DocumentationContent-module__m-r-20___w0PL_`,
	"mR24": `DocumentationContent-module__m-r-24___ePQCC`,
	"mR30": `DocumentationContent-module__m-r-30___FlPAe`,
	"mR40": `DocumentationContent-module__m-r-40___NtlHU`,
	"borderR3": `DocumentationContent-module__border-r-3___JVhIX`,
	"borderR4": `DocumentationContent-module__border-r-4___LRTfT`,
	"borderR6": `DocumentationContent-module__border-r-6___vGGFE`,
	"borderR10": `DocumentationContent-module__border-r-10____84gO`,
	"borderR12": `DocumentationContent-module__border-r-12___YQHIP`,
	"borderR16": `DocumentationContent-module__border-r-16___LYj9g`,
	"borderR50": `DocumentationContent-module__border-r-50___ElL3Y`,
	"primaryBorder": `DocumentationContent-module__primary-border___d126n`,
	"primaryBorderB": `DocumentationContent-module__primary-border-b___tel_5`,
	"primaryBorderT": `DocumentationContent-module__primary-border-t___Xi3yG`,
	"primaryBorderL": `DocumentationContent-module__primary-border-l___Pl0BR`,
	"primaryBorderR": `DocumentationContent-module__primary-border-r___tw48A`,
	"secondaryBorder": `DocumentationContent-module__secondary-border___al8Wz`,
	"secondaryBorderB": `DocumentationContent-module__secondary-border-b___I2uXq`,
	"secondaryBorderT": `DocumentationContent-module__secondary-border-t___nZDie`,
	"secondaryBorderL": `DocumentationContent-module__secondary-border-l___BxP_7`,
	"secondaryBorderR": `DocumentationContent-module__secondary-border-r___oLz63`,
	"gap0": `DocumentationContent-module__gap-0___mP2bC`,
	"gap2": `DocumentationContent-module__gap-2___q0Zdj`,
	"gap4": `DocumentationContent-module__gap-4___Jf6Yq`,
	"gap5": `DocumentationContent-module__gap-5___OFONh`,
	"gap6": `DocumentationContent-module__gap-6___riDAe`,
	"gap8": `DocumentationContent-module__gap-8___DrTa7`,
	"gap10": `DocumentationContent-module__gap-10___OdAEa`,
	"gap12": `DocumentationContent-module__gap-12___hKoz6`,
	"gap14": `DocumentationContent-module__gap-14___HMRZJ`,
	"gap16": `DocumentationContent-module__gap-16___nwUHn`,
	"gap18": `DocumentationContent-module__gap-18___IViNS`,
	"gap20": `DocumentationContent-module__gap-20___DRylB`,
	"gap24": `DocumentationContent-module__gap-24___rAc1x`,
	"gap26": `DocumentationContent-module__gap-26___Iblkc`,
	"gap30": `DocumentationContent-module__gap-30___pMnLm`,
	"gap32": `DocumentationContent-module__gap-32___Tyc1n`,
	"gap40": `DocumentationContent-module__gap-40___dag90`,
	"gap50": `DocumentationContent-module__gap-50___diwTk`,
	"flex1": `DocumentationContent-module__flex-1___IkQ6t`,
	"flexNone": `DocumentationContent-module__flex-none___zYnFj`,
	"flexColumn": `DocumentationContent-module__flex-column___rA0Nk`,
	"flexRow": `DocumentationContent-module__flex-row___IkJvj`,
	"verticallyCentered": `DocumentationContent-module__vertically-centered___WykJr`,
	"horizontallyCentered": `DocumentationContent-module__horizontally-centered___x9RML`,
	"horizontallyEnd": `DocumentationContent-module__horizontally-end___BBKjl`,
	"verticallyStart": `DocumentationContent-module__vertically-start___IhzRU`,
	"spaceBetween": `DocumentationContent-module__space-between___EgFbA`,
	"flexWrap": `DocumentationContent-module__flex-wrap___SLvf3`,
	"height100": `DocumentationContent-module__height-100___AEcdK`,
	"width50": `DocumentationContent-module__width-50___yp76z`,
	"width100": `DocumentationContent-module__width-100___BpoCz`,
	"cursorPointer": `DocumentationContent-module__cursor-pointer___iZjj3`,
	"cursorNotAllowed": `DocumentationContent-module__cursor-not-allowed___mlM5K`,
	"absoluteCentered": `DocumentationContent-module__absolute-centered___bNNRX`,
	"absolute": `DocumentationContent-module__absolute___fueqX`,
	"relative": `DocumentationContent-module__relative___Jx5st`,
	"fixed": `DocumentationContent-module__fixed___Fk79K`,
	"visible": `DocumentationContent-module__visible___Jnohw`,
	"invisible": `DocumentationContent-module__invisible___pyXnZ`,
	"col90": `DocumentationContent-module__col-90___fK14X`,
	"colAuto": `DocumentationContent-module__col-auto___eNZ40`,
	"medicalTabs": `DocumentationContent-module__medical-tabs___PvbP5`,
	"medicalTableNew": `DocumentationContent-module__medical-table-new___RyqDL`,
	"noPagination": `DocumentationContent-module__no-pagination___Iyyjs`,
	"medicalTableEmpty": `DocumentationContent-module__medical-table-empty___hwAeh`,
	"iconBtn": `DocumentationContent-module__icon-btn___NXwAJ`,
	"searchIcon": `DocumentationContent-module__search-icon___H5Is9`,
	"disableSelect": `DocumentationContent-module__disable-select___RDtSQ`,
	"breakWord": `DocumentationContent-module__break-word___w3CIi`,
	"popupClearBtn": `DocumentationContent-module__popup-clear-btn___fojBu`,
	"scrollMB20": `DocumentationContent-module__scroll-m-b-20___wLRIm`,
	"wrapper": `DocumentationContent-module__wrapper___fytH0`,
	"item": `DocumentationContent-module__item___bf9C8`,
	"note": `DocumentationContent-module__note___LNA1q`
};
module.exports = ___CSS_LOADER_EXPORT___;
